import ApplicationController from './application_controller'
import { FetchRequest } from '@rails/request.js'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = [ "modal", "dialog", "closeButton", "saveButton", "modalBody", "title", "footer", "header" ]

  connect () {
    this.element[this.identifier] = this
    this.closeEventHandlers = [];
  }
  showFullscreen (event) {
    this.dialogTarget.classList.remove('modal-xl')
    this.dialogTarget.classList.add('modal-fullscreen')
    this.show(event)
  }
  show(event) {
    if(event) {
    event.preventDefault()
      event.stopPropagation();
    }

    this.closeEventHandlers = [];

    this.hideAllFloatedElements()
    this.modalTarget.style.display = "block"
    this.modalTarget.style.opacity = "1"
    this.modalTarget.classList.add("show")
    this.modalTarget.classList.remove("hide")
  }
  close () {
    this.modalTarget.style.display = "none"
    this.modalTarget.style.opacity = "0"
    this.modalTarget.classList.remove("show")
    this.modalTarget.classList.add("hide")

    // clean up fullscreen mode
    this.dialogTarget.classList.add('modal-xl')
    this.dialogTarget.classList.remove('modal-fullscreen')

    for (var i = 0; i < this.closeEventHandlers.length; i++) {
      this.closeEventHandlers[i]();
    }
  }
  setTitle (nTitle) {
    this.titleTarget.innerText = nTitle
  }
  setContent (nElement) {
    this.modalBodyTarget.innerHTML = ''

    if (typeof nElement === 'string') {
      this.modalBodyTarget.innerHTML = nElement
    } else {
      this.modalBodyTarget.appendChild(nElement)
    }
  }
  setFooter (nElement) {
    this.clearContent(this.footerTarget)
    this.footerTarget.appendChild(nElement)
  }
  clearContent (trgElement) {
    if(trgElement == undefined) {
      trgElement = this.modalBodyTarget
    }
    while (trgElement.firstChild) {
      trgElement.removeChild(trgElement.firstChild);
    }
  }
  showFooter () {
    this.footerTarget.style.display = "block"
  }
  hideTitle () {
    console.log("hiding title…")
    this.titleTarget.style.border = "1px solid red"
  }
  hideFooter () {
    console.log("hiding footer…")
    this.footerTarget.style.display = "none"
  }
  hideHeader () {
    console.log("hiding header…")
    this.headerTarget.style.display = "none"
  }

  setViewMode(newMode) {
    this.modalTarget.classList.remove('standardModal')
    this.modalTarget.classList.add(newMode)
  }

  async loadHTMLModal(url, params = {}) {
    this.clearModalContent();
    this.getModalController().show();
    this.getModalController().hideFooter();

    params.inModal = 1

    const request = new FetchRequest('get', url, { query: params });
    const response = await request.perform();
    if (response.ok) {
      const html = await response.html;
      this.setContent(html);
    } else {
      alert("Error in loadHTMLModal")
    }
  }
}
